import { useEffect } from "react";

export function useDocumentTitle(title: string): void {
  useEffect((): void => {
    document.title = `${title} · PasswordFlow`;
  }, [title]);
}
